/**
 * A régua de números da `Pagination`.
 *
 * Fica em arquivo próprio porque um módulo de componente que exporta função
 * quebra o Fast Refresh do Vite — mesmo motivo de `button.variants.ts`.
 */

/** Quantos números a régua do desktop mostra antes de usar reticências. */
const MAXIMO_VISIVEL = 7;

/**
 * Sempre com a primeira e a última página visíveis: são as duas que o usuário
 * mais procura ("voltar ao começo", "ver o fim da fila"), e sem elas ele precisa
 * clicar em "Próxima" até chegar lá.
 */
export const paginationRange = (
  page: number,
  totalPages: number
): (number | "reticencias")[] => {
  if (totalPages <= MAXIMO_VISIVEL) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  if (page <= 4) {
    return [1, 2, 3, 4, 5, "reticencias", totalPages];
  }

  if (page >= totalPages - 3) {
    return [
      1,
      "reticencias",
      totalPages - 4,
      totalPages - 3,
      totalPages - 2,
      totalPages - 1,
      totalPages,
    ];
  }

  return [
    1,
    "reticencias",
    page - 1,
    page,
    page + 1,
    "reticencias",
    totalPages,
  ];
};
